import * as React from "react";
import QuestionLabel from "./QuestionLabel";
import QuestionError from "./QuestionError";
import getControlProps from "../helpers/getControlProps";

interface SectionQuestionProps {
  question: any;
  onChangeSection: any;
  onChange: any;
  answer: any;
  error: string;
}

class SectionQuestion extends React.Component<SectionQuestionProps, {}> {
  onChange = (e: React.FormEvent<HTMLSelectElement>) => {
    const selectedChoiceID = parseInt(e.currentTarget.value);
    let selectedChoiceText = "";

    if (selectedChoiceID > 0) {
      this.props.question.SurveyQuestionChoices.forEach((choice: any) => {
        if (choice.ChoiceID === selectedChoiceID) {
          selectedChoiceText = choice.ChoiceText;
        }
      });
    }

    this.props.onChangeSection(
      this.props.question.QuestionID,
      selectedChoiceID
    );

    //We need to keep track of the text answer and the id for Section Questions
    const answer = { answer: selectedChoiceText, answerID: selectedChoiceID };
    this.props.onChange(this.props.question, answer);
  };

  render() {
    return (
      <div>
        <QuestionLabel question={this.props.question} />
        <select
          value={this.props.answer ? this.props.answer.answerID || 0 : 0}
          onChange={this.onChange}
          {...getControlProps(this.props.question, this.props.error)}
        >
          <option value={""}>{this.props.question.DefaultSelectText}</option>
          {this.props.question.SurveyQuestionChoices.map(function(choice: any) {
            return (
              <option key={choice.ChoiceID} value={choice.ChoiceID}>
                {choice.ChoiceText}
              </option>
            );
          })}
        </select>
        <QuestionError
          questionId={this.props.question.QuestionID}
          error={this.props.error}
        />
      </div>
    );
  }
}

export default SectionQuestion;
